<template>
	<b-container v-if="isLoggedIn" fluid class="dashboard px-4 px-lg-4 px-md-5 px-sm-5 px-0" v-animate-css="'fadeIn'">
        <img class="img-logo-other mb-5 d-none d-lg-block d-xl-block" src="/public/images/icons/icon-other-grey.png" />
        <div class="d-none d-lg-flex d-xl-flex justify-content-between">
            <h1>{{$route.meta.title}}</h1>
        </div>
        <div class="mt-4">
            <h3 class="mb-3 fs-24">{{$route.meta.subtitle}}</h3>
        </div>

		<div class="dashContent">
		<b-row class="dashRow firstDash">
			<b-col v-if="VReligible" md="12">
				<div class="mainCard">
					<b-card
						img-src="/public/images/reg_VR.jpg"
						img-alt="Virtual Challenge Registration"
						img-top
					>
					<div class="statusContainer">
						<div class="statusIdle" v-if="!virtualTransactionData&&!virtualEventClosed">
							<h2>{{ $t("status.VRidle.head") }}</h2>
								<b-card-text>
								{{ $t("status.VRidle.desc") }}
								</b-card-text>
								<b-row v-html="$t('status.VRidle.step')">
								</b-row>

                                <div class="clearfix">&nbsp;</div>

								<b-button v-b-modal.registrationModal block variant="primary" @click="channel='VIRTUAL'">{{ $t("status.VRidle.btn") }}</b-button>

								<!-- <b-button v-b-modal.connectModal class="btn-connect fit" v-html="$t('register.form.virtual.connect.fit')"></b-button>
								<b-button v-b-modal.connectModal class="btn-connect endo" v-html="$t('register.form.virtual.connect.endo')"></b-button>

								<b-button class="btn-connect fit" v-html="$t('register.form.virtual.connect.fit')"></b-button>
								<connect-modal :connectModal="showConnectModal"/>
								<b-button @click="showConnectModal = !showConnectModal" class="btn-connect endo" v-html="$t('register.form.virtual.connect.endo')"></b-button>
								<b-button @click="showConnectModal = !showConnectModal" class="btn-connect strava" v-html="$t('register.form.virtual.connect.strava')"></b-button>
								<b-button @click="showConnectModal = !showConnectModal" class="btn-connect garmin" v-html="$t('register.form.virtual.connect.garmin')"></b-button> -->
								
						</div>
						<registration-modal :modal-data="channel"/>
						
						<!-- <b-button @click="showPaymentModal = !showPaymentModal" variant="primary">{{ $t("status.pay.btn") }}</b-button>
						<payment-modal :show="showPaymentModal" :transactionData="virtualTransactionData"/> -->

						<div class="statusVRclosed" v-if="virtualEventClosed&&!virtualTransactionData">
							<h2>{{ $t("status.VRclosed.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusClosed"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.VRclosed.label") }}</h6>
										<p v-html="$t('status.VRclosed.desc')"></p>
									</b-col>
								</b-row>
						</div>

						<div class="statusVRconnect" v-if="!VRactivated&&virtualTransactionData&&virtualTransactionData.data.trnsConfirmed=='1'">
							<h2>{{ $t("status.VRconnect.head") }}</h2>
							<!-- <pre v-if="virtualTransactionData">{{virtualTransactionData.data}}</pre> -->
							<b-row class="status">
								<b-col sm="auto">
									<svg-image image="statusConnect"/>
								</b-col>
								<b-col>
									<h6>{{ $t("status.VRconnect.label") }}</h6>
									<i18n path="status.VRconnect.desc" tag="p">
										<span place="timelimit"><strong>{{virtualTransactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong></span>
									</i18n>
								</b-col>
							</b-row>

							<div class="connectGroup">
								<b-button class="btn-connect fit" :href="'https://fitsync.borobudurmarathon.com/google/auth/'+userProfile.memberId" v-html="$t('register.form.virtual.connect.fit')"></b-button>
								<!-- <connect-modal :showConnectModal="showConnectModal" :targetConnectModal="targetConnectModal"/> -->
								<b-button @click="toggleConnectModal('endo')" class="btn-connect endo" v-html="$t('register.form.virtual.connect.endo')"></b-button>
								<b-button @click="toggleConnectModal('garmin')" class="btn-connect garmin" v-html="$t('register.form.virtual.connect.garmin')"></b-button>
							</div>
						</div>

						<div class="statusVRactivated" v-if="VRactivated&&virtualTransactionData&&virtualTransactionData.data.trnsConfirmed=='1'">
							<h2>{{ $t("status.VRactivated.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusWait"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.VRactivated.label") }}</h6>
										<p>{{ $t("status.VRactivated.desc") }}</p>
									</b-col>
								</b-row>
						</div>

						<div class="statusVRrunning"  v-if="virtualTransactionData&&virtualTransactionData.data.trnsConfirmed=='1'&&submissionPeriodOpen">
							<h2>{{ $t("status.VRrunning.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusSuccess"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.VRrunning.label") }}</h6>
										<p>{{ $t("status.VRrunning.desc") }}</p>
									</b-col>
								</b-row>
						</div>

						<div class="statusVRcomplete" v-if="virtualTransactionData&&virtualTransactionData.data.trnsConfirmed=='1'&&VRSubmitted">
							<h2>{{ $t("status.VRcomplete.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusSuccess"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.VRcomplete.label") }}</h6>
										<p>{{ $t("status.VRcomplete.desc") }}</p>
									</b-col>
								</b-row>
						</div>

						<div class="statusVRmissed" v-if="virtualTransactionData&&virtualTransactionData.data.trnsConfirmed=='1'&&VRMissed">
							<h2>{{ $t("status.VRmissed.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusClosed"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.VRmissed.label") }}</h6>
										<p v-html="$t('status.VRmissed.desc')"></p>
									</b-col>
								</b-row>
						</div>
					</div>

					<!-- <pre v-if="virtualTransactionData">{{virtualTransactionData.linked.evrlTrnsId[0]}}</pre> -->
					<!-- <pre>{{virtualTransactionData}}</pre> -->
					<connect-modal :showConnectModal="showConnectModal" :targetConnectModal="targetConnectModal"/>
					<div class="VRdata" v-if="VRactivated&&virtualTransactionData&&virtualTransactionData.data.trnsConfirmed=='1'">
						<b-row>
							<b-col sm="4" class="regCategory">
								<div class="M" v-if="virtualTransactionData.linked.evrlTrnsId[0].evpaEvncId=='775'">
									<img src="/public/images/patch_M.png">
								</div>
								<div class="HM" v-if="virtualTransactionData.linked.evrlTrnsId[0].evpaEvncId=='776'">
									<img src="/public/images/patch_HM.png">
								</div>
								<div class="10K" v-if="virtualTransactionData.linked.evrlTrnsId[0].evpaEvncId=='777'">
									<img src="/public/images/patch_10K.png">
								</div>
								<div class="FR" v-if="virtualTransactionData.linked.evrlTrnsId[0].evpaEvncId=='778'">
									<img src="/public/images/patch_FR.png">
								</div>
								<div class="regID">
									<p class="sub">{{ $t("register.form.virtual.data.reg") }}</p>
									<p class="ID"><strong>{{virtualTransactionData.data.trnsRefId}}</strong></p>
									<p class="date">{{virtualTransactionData.data.trnsConfirmTime | moment("D MMMM YYYY - hh:mm")}} WIB (GMT+7)</p>
								</div>
							</b-col>
							<b-col>
								<div v-if="connectionPeriodOpen">
									<div class="groupLabel"><label>{{ $t("register.form.virtual.data.app") }}</label></div>
									<div class="VRapp">
										<b-row v-for="(trackerChannel, trackerName) in trackerChannels" :key="trackerName" :class="trackerName">
											<b-col sm="8">
												<p v-if="trackerName=='fit'"><img src="/public/images/app/fit.png"> {{trackerChannel.account}}</p>
												<p v-if="trackerName=='endomondo'"><img src="/public/images/app/endomondo.png"> {{trackerChannel.account}}</p>
												<p v-if="trackerName=='garmin'"><img src="/public/images/app/garmin.png"> {{trackerChannel.account}}</p>
											</b-col>
											<b-col sm="4">
												<b-button v-if="trackerChannel.connected" block class="btn-disconnect" @click="disconnectTracker(trackerChannel)">{{ $t("register.form.virtual.auth.disconnect") }}</b-button>
												<b-button v-if="!trackerChannel.connected&&trackerName=='fit'" block :href="'https://fitsync.borobudurmarathon.com/google/auth/'+userProfile.memberId" class="btn-disconnect">{{ $t("register.form.virtual.auth.connect") }}</b-button>
												<b-button v-if="!trackerChannel.connected&&trackerName=='endomondo'" block @click="toggleConnectModal('endo')" class="btn-disconnect">{{ $t("register.form.virtual.auth.connect") }}</b-button>
												<b-button v-if="!trackerChannel.connected&&trackerName=='garmin'" block @click="toggleConnectModal('garmin')" class="btn-disconnect">{{ $t("register.form.virtual.auth.connect") }}</b-button>
											</b-col>
										</b-row>
									</div>
								</div>
								<div class="deliveryStatus" v-if="patchShipped">
									<div class="groupLabel"><label>{{ $t("register.form.virtual.data.shipping") }}</label></div>
									<div class="VRdelivery">
										<b-row>
											<b-col md="auto">
												<img src="/public/images/jne.png" style="width:40px">
											</b-col>
											<b-col md="auto">
												<p><strong>CGK2H03789568816</strong></p>
											</b-col>
										</b-row>
										<p>SHIPMENT RECEIVED BY JNE COUNTER OFFICER AT [JAKARTA]</p>
									</div>
								</div>

								<div class="groupLabel"><label>{{ $t("register.form.virtual.data.address") }}</label></div>
								<div class="VRaddress">
									<p>{{virtualTransactionData.linked.evrlTrnsId[0].evpaDeliveryAddress}}</p>
									<p>{{deliveryLocation}}</p>
									<p>{{countryObject[virtualTransactionData.linked.evrlTrnsId[0].evpaCountry]}}</p>
									<p>{{virtualTransactionData.linked.evrlTrnsId[0].evpaPostCode}}</p>
									<p>{{virtualTransactionData.linked.evrlTrnsId[0].evpaDeliveryPhone}}</p>
								</div>
								
							</b-col>
						</b-row>
					</div>
					</b-card>
				</div>
			</b-col>
			
			<b-col v-if="!VReligible&&invited" v-bind:class="{ dashDisabled: ballotStatus.confirmedViaSaveDuit }" md="8">
				<div class="mainCard">
					<b-card
						img-src="/public/images/reg.jpg"
						img-alt="Registration"
						img-top
					>
					<div class="statusContainer">
						<div class="statusIdle" v-if="ballotStatus.readyToRegister">
							<h2>{{ $t("status.idle.head") }}</h2>
								<b-form @submit="onSubmit">
									<b-form-group id="" :label="$t('status.idle.label')" label-for="" :description="$t('status.idle.desc')">
										<b-form-select :options="regChannel" v-model="channel" :disabled="ballotStatus.confirmedViaSaveDuit">
										<!-- <b-form-select-option value="regBallot">Ballot Casting</b-form-select-option> 
											<b-form-select-option value="regFrq">Fast Runner Qualifying</b-form-select-option>
											<b-form-select-option value="regBJ">Bank Jateng Program</b-form-select-option>
											<b-form-select-option value="regTravel">Travel Agent Partners</b-form-select-option>-->
										</b-form-select>
									</b-form-group>
									<b-button v-if="!invited" v-b-modal.registrationModal variant="primary" :disabled="channel==null">AAA{{ $t("status.idle.btn") }}</b-button>
								</b-form>
						</div>
						<registration-modal :modal-data="channel"/>
						
						<div class="statusWait" v-if="ballotStatus.waiting">
							<h2>{{ $t("status.wait.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusWait"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.wait.label") }}</h6>
										<p>{{ $t("status.wait.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusWait" v-if="ballotStatus.eliteSelection">
							<h2>{{ $t("status.eliteSelection.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusWait"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.eliteSelection.label") }}</h6>
										<p>{{ $t("status.eliteSelection.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusFRQWait" v-if="ballotStatus.frqWaiting&&!ballotStatus.approved&&userProfile.fastRunnerInfo.mmfrStatus==0">
							<h2>{{ $t("status.FRQwait.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusWait"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.FRQwait.label") }}</h6>
										<p v-html="$t('status.FRQwait.desc')"></p>
									</b-col>
								</b-row>
						</div>
						<div class="statusSwitched" v-if="userProfile.fastRunnerInfo&&userProfile.fastRunnerInfo.mmfrStatus==2">
							<h2>{{ $t("status.switched.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusSwitched"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.switched.label") }}</h6>
										<p v-html="$t('status.switched.desc')"></p>
									</b-col>
								</b-row>
						</div>
						<div class="statusDrawing" v-if="ballotStatus.drawing">
							<h2>{{ $t("status.drawing.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusDrawing"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.drawing.label") }}</h6>
										<p>{{ $t("status.drawing.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<!-- <pre>{{ballotDataDetail}}</pre> -->
						<!-- <div v-if="transactionData&&transactionData.data.trnsConfirmed==1">
							<h1>Confirmed nih...</h1>
						</div> -->
						<div class="statusPay" v-if="ballotStatus.approved&&!ballotStatus.FRQaccepted&&transactionData&&transactionData.data.trnsConfirmed!=1">
							<h2>{{ $t("status.pay.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusPay"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.pay.label") }}</h6>
										<i18n path="status.pay.desc" tag="p">
											<span place="timelimit"><strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong></span>
										</i18n>
									</b-col>
								</b-row>
							<b-button v-if="!ballotDataDetail.evpaJersey||(ballotDataDetail.evpaJersey&&ballotDataDetail.evpaJersey=='-')" @click="showJerseyModal = !showJerseyModal" variant="primary">{{ $t("status.pay.jbtn") }}</b-button>
							<jersey-modal :showJersey="showJerseyModal"/>

							<b-button v-if="ballotDataDetail.evpaJersey&&ballotDataDetail.evpaJersey!='-'"  @click="showPaymentModal = !showPaymentModal" variant="primary">{{ $t("status.pay.btn") }}</b-button>
							<payment-modal :show="showPaymentModal" :transactionData="transactionData" :ballotStatus="ballotStatus"/>
						</div>

						<div class="statusFRQaccepted" v-if="ballotStatus.FRQaccepted&&transactionData&&transactionData.data.trnsConfirmed!=1">
							<h2>{{ $t("status.FRQaccepted.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusPay"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.FRQaccepted.label") }}</h6>
										<p v-html="$t('status.FRQaccepted.desc')"></p>
									</b-col>
								</b-row>
							<b-button v-if="!ballotDataDetail.evpaJersey||ballotDataDetail.evpaJersey=='-'" @click="showJerseyModal = !showJerseyModal" variant="primary">{{ $t("status.pay.jbtn") }}</b-button>
							<jersey-modal :showJersey="showJerseyModal"/>

							<b-button disabled="disabled" v-if="!(!ballotDataDetail.evpaJersey||ballotDataDetail.evpaJersey=='-')"  @click="showPaymentModal = !showPaymentModal" variant="primary">{{ $t("status.pay.btn") }}</b-button>
							<payment-modal :show="showPaymentModal" :transactionData="transactionData"/>
						</div>

						<div class="statusTransferring" v-if="ballotStatus.bibTransferInProgess">
							<h2>{{ $t("status.transferring.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusTransferring"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.transferring.label") }}</h6>
										<p>{{ $t("status.transferring.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusSuccess" v-if="ballotStatus.confirmed">
							<h2>{{ $t("status.success.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusSuccess"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.success.label") }}</h6>
										<p>{{ $t("status.success.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusBJsuccess" v-if="ballotStatus.confirmedViaBankJateng">
							<h2>{{ $t("status.BJsuccess.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<img src="https://assets.heartwork.co.id/bormar/bankjateng.svg" class="bankJateng">
									</b-col>
									<b-col>
										<h6>{{ $t("status.BJsuccess.label") }}</h6>
										<p>{{ $t("status.BJsuccess.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusUnlucky" v-if="ballotStatus.unlucky">
							<h2>{{ $t("status.unlucky.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusUnlucky"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.unlucky.label") }}</h6>
										<p>{{ $t("status.unlucky.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusUnpaid" v-if="ballotStatus.unpaid">
							<h2>{{ $t("status.unpaid.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusUnpaid"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.unpaid.label") }}</h6>
										<p>{{ $t("status.unpaid.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusTransferred" v-if="ballotStatus.transferred">
							<h2>{{ $t("status.transferred.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusTransferred"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.transferred.label") }}</h6>
										<p>{{ $t("status.transferred.desc") }}</p>
									</b-col>
								</b-row>
						</div>
						<div class="statusClosed" v-if="ballotStatus.closed">
							<h2>{{ $t("status.closed.head") }}</h2>
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="statusClosed"/>
									</b-col>
									<b-col>
										<h6>{{ $t("status.closed.label") }}</h6>
										<p v-html="$t('status.closed.desc')"></p>
									</b-col>
								</b-row>
						</div>
					</div>

					<div class="regData" v-if="ballotData&&ballotDataDetail">
						<!-- <pre>
							{{transferInfo}}
						</pre> -->
						<!-- <table>
								<tbody><tr>
									<td class="heady">Registration Code</td>
									<td>{{ballotData.mregOrderId}}</td>
								</tr><tr>
									<td class="heady">Registration Date</td>
									<td>{{ballotData.mregCreatedTime | moment("D MMMM YYYY - hh:mm")}} WIB (GMT+7)</td>
								</tr></tbody>
						</table> -->

						<b-row class="regCategory">
							<b-col md="auto">
								<div class="groupLabel"><label>{{ $t("regData.category.race") }}</label></div>
								<h1>{{ballotDataDetail.evrlEvpaCategory}}</h1>
							</b-col>
							<b-col>
								<div class="groupLabel"><label>{{ $t("regData.category.code") }}</label></div>
								<h5>{{ballotData.mregOrderId}}</h5>
								<p>{{ballotData.mregCreatedTime | moment("D MMMM YYYY - HH:mm")}} WIB (GMT+7)</p>
							</b-col>
						</b-row>

						<div class="groupLabel"><label>{{ $t("regData.details.head") }}</label></div>
						<table>
								<tbody>
								<tr v-if="ballotDataDetail.evpaWave&&ballotDataDetail.evpaWave!='00:00'">
									<td class="heady">{{ $t("regData.details.corral") }}</td>
									<td>{{ballotDataDetail.evpaWave}}</td>
								</tr>
								<tr v-if="ballotDataDetail.evpaFRtime&&ballotDataDetail.evpaFRtime!='00:00'">
									<td class="heady">{{ $t("regData.details.corral") }}</td>
									<td>{{ballotDataDetail.evpaFRtime}}</td>
								</tr>
								<tr>
									<td class="heady">{{ $t("regData.details.bib") }}</td>
									<td>{{ballotDataDetail.evpaBIBName}}</td>
								</tr><tr v-if="ballotDataDetail.evpaJersey!='-'">
									<td class="heady">{{ $t("regData.details.jersey") }}</td>
									<td>{{ballotDataDetail.evpaJersey}}</td>
								</tr><tr v-if="ballotDataDetail.evpaCommunity&&ballotDataDetail.evpaCommunity!='-'">
									<td class="heady">{{ $t("regData.details.community") }}</td>
									<td>{{ballotDataDetail.evpaCommunity}}</td>
								</tr>
								</tbody>
						</table>
						<div v-if="userProfile.fastRunnerInfo" class="FRQdata">
							<div class="groupLabel"><label>{{ $t("regData.frq.head") }}</label></div>
							<table>
									<tbody><tr>
										<td class="heady">{{ $t("regData.frq.qrace") }}</td>
										<td>{{userProfile.fastRunnerInfo.mmfrEventName}}</td>
									</tr><tr>
										<td class="heady">{{ $t("regData.frq.qcategory") }}</td>
										<td>{{userProfile.fastRunnerInfo.mmfrDescription}}</td>
									</tr><tr>
										<td class="heady">{{ $t("regData.frq.qtime") }}</td>
										<td>{{userProfile.fastRunnerInfo.mmfrResultTime}}</td>
									</tr></tbody>
							</table>
						</div>
						<div class="groupLabel"><label>{{ $t("regData.emergency.head") }}</label></div>
						<table>
								<tbody><tr>
									<td class="heady">{{ $t("regData.emergency.name") }}</td>
									<td>{{ballotDataDetail.evpaEmergencyContactName}}</td>
								</tr><tr>
									<td class="heady">{{ $t("regData.emergency.number") }}</td>
									<td>{{ballotDataDetail.evpaEmergencyContactNumber}}</td>
								</tr><tr>
									<td class="heady">{{ $t("regData.emergency.medic") }}</td>
									<td>{{ballotDataDetail.evpaMedicalTreatment}}</td>
								</tr></tbody>
						</table>
					</div>
						<!-- <b-form-group id="evpaBIBName-group" label="Name On BIB" label-for="evpaBIBName">
							<b-form-input
								id="evpaBIBName"
								v-model="form.evpaBIBName"
								:state="formStatus.evpaBIBName.state"
								required
								placeholder="Enter Your desired name on BIB"
							></b-form-input>
						</b-form-group>
						<b-form-group id="evpaEvncId-group" label="Category" label-for="evpaEvncId">
							<b-form-select
								id="evpaEvncId"
								v-model="form.evpaEvncId"
								:options="categories"
								required
							></b-form-select>
						</b-form-group>
						<b-form-group id="evpaWave-group" label="Target Finish Time" label-for="evpaWave">
							<vue-timepicker input-class="form-control" v-model="form.evpaWave" format="hh:mm"></vue-timepicker>
						</b-form-group>
						<b-button href="#" variant="primary">Join Now</b-button>-->
						<div v-if="invited">
							<div class="groupLabel"><label>KETENTUAN TAMBAHAN BOROBUDUR MARATHON ELITE RACE 2020</label></div>
							<ol>
								<li>Atlet wajib menjalani tes Covid-19 minimal 3 (tiga) kali, sebelum berangkat ke tempat acara, selama berada di lokasi acara, dan sebelum pulang dari tempat acara. </li>
								<li>Apabila atlet gagal menjalani salah satu tes Covid-19 , atau salah satu hasil tes menunjukan hasil positif maka atlet akan dihimbau untuk masuk ke dalam tempat atau ruang isolasi yang ditentukan penyelenggara, dan tidak berhak mengikuti acara Borobudur Marathon Elite Race 2020.</li>
								<li>Atlet tidak diperkenankan untuk didampingi oleh pelatih selama acara Borobudur Marathon Elite Race 2020 berlangsung.</li>
							 	<li>Atlet tidak diperkenankan untuk menerima dan melakukan kunjungan selama acara Borobudur Marathon Elite Race 2020 berlangsung.</li>
								<li>Atlet wajib tinggal di tempat akomodasi atlet yang sudah ditentukan oleh penyelenggara. Apabila atlet menginap di tempat lain selain akomodasi yang sudah disediakan, atlet dapat didiskualifikasi dan tidak dapat berpartisipasi dalam perlombaan.​</li>
								<li>Atlet harus mengikuti protokol kesehatan yang ditetapkan penyelenggara, termasuk namun tidak terbatas kepada, pembatasan jarak fisik, penggunaan masker, mencuci tangan dan menggunakan hand sanitizer . Pelanggaran pelaksanaan protokol kesehatan dapat menjadi pertimbangan penyelenggara untuk menghentikan atlet dalam keikutsertaan mereka di Borobudur Marathon Elite Race 2020​</li>
								<li>Atlet diharuskan menggunakan moda transportasi dan fasilitas yang sudah disediakan oleh penyelenggara. Pelanggaran penggunaan moda transportasi dan fasilitas yang sudah disediakan oleh penyelenggara, dapat menjadi pertimbangan untuk menghentikan atlet dalam keikutsertaan mereka di Borobudur Marathon Elite Race 2020.</li>
								<li>Atlet wajib mengikuti jadwal rangkaian acara yang dibuat oleh Panitia Borobudur Marathon Elite Race 2020.</li>
								<li>Atlet wajib mengikuti assesment yang telah ditetapkan oleh penyelenggara bersama medical director,  14 hari sebelum lomba dan 14 hari setelah lomba berlangsung.​</li>
								<li>Hal-hal lain terkait syarat dan ketentuan keikutsertaan dalam Borobudur Marathon Elite Race 2020 dapat ditambahkan sewaktu-waktu oleh penyelenggara dan akan menginformasikan penambahan itu kepada para atlet undangan Borobudur Marathon Elite Race 2020.</li>
							</ol>
							<b-button v-if="!transactionData" v-b-modal.registrationModal variant="primary" :disabled="channel==null">{{ $t("status.idle.btn") }}</b-button>
						</div>
					</b-card>
				</div>
			</b-col>
		</b-row>
		<!-- <pre>{{ballotStatus}}</pre> -->
		<div v-if="!event2020">
			<b-row class="dashRow" v-bind:class="{ dashDisabled: !ballotStatus.readyToRegister||!saveDuitOpen }">
				<b-col md="6">
						<b-card
							:title="$t('bankjateng.card.head')"
							img-src="/public/images/bj.jpg"
							img-alt="Bank Jateng Program"
							img-top
							class="dashCard"
						>
							<div class="bankjatengCard">
								<b-card-text>
									{{ $t("bankjateng.card.desc") }}
								</b-card-text>
								<b-button v-if="!programData" v-b-modal.registrationModal block variant="primary" @click="channel='JATENG'" :disabled="!ballotStatus.readyToRegister||true">{{ $t("bankjateng.card.btn") }}</b-button>
								<!-- <registration-modal/> -->
							</div>
							<div class="bankjatengStatus" v-if="ballotStatus.readyToRegister">
								<div class="statusSuccess" v-if="ballotStatus.confirmedViaSaveDuit">
									<b-row class="status">
										<b-col>
											<svg-image image="statusSuccess"/>
											<h6>{{ $t("bankjateng.status.success.label") }}</h6>
											<p>{{ $t("bankjateng.status.success.desc") }}</p>
										</b-col>
									</b-row>
								</div>
								<div v-else>
									<div class="statusPay" v-if="programData&&!ballotStatus.waitingSaveduitSettlement&&!ballotStatus.saveduitExpired">
										<b-row class="status">
											<b-col>
												<svg-image image="statusPay"/>
												<h6>{{ $t("bankjateng.status.pay.label") }}</h6>
												<i18n path="bankjateng.status.pay.desc" tag="p">
													<span place="timelimit"><strong>{{programData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong></span>
												</i18n>
												<!-- <p>Please ensure to make the payment before <strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong> to complete your Friendship Run registration.</p> -->
											</b-col>
										</b-row>
										<b-button v-b-modal.paymentModal block variant="primary">{{ $t("bankjateng.status.pay.btn") }}</b-button>
										<payment-modal :transactionData="programData"/>
									</div>
									<div class="statusPay" v-if="programData&&ballotStatus.waitingSaveduitSettlement">
										<b-row class="status">
											<b-col>
												<svg-image image="statusPay"/>
												<h6>{{ $t("bankjateng.status.pay.label") }}</h6>
												<i18n path="bankjateng.status.pay.desc" tag="p">
													<span place="timelimit">
														<strong>{{programData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong>
													</span>
												</i18n>
												<!-- <h4>No ref {{saduDetail.saduSaveduitNumber}}</h4> -->
												<!-- <h4>Jumlah dooet {{saduDetail.saduAmount | currency}}</h4> -->
												<!-- <p>Please ensure to make the payment before <strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong> to complete your Friendship Run registration.</p> -->
											</b-col>
										</b-row>
										<b-button v-b-modal.paymentModal block variant="primary">{{ $t("bankjateng.status.pay.btn") }}</b-button>
										<payment-modal :transactionData="programData"/>
									</div>
									<div class="statusUnpaid" v-if="ballotStatus.saveduitExpired">
										<b-row class="status">
											<b-col>
												<svg-image image="statusUnpaid"/>
												<h6>{{ $t("bankjateng.status.unpaid.label") }}</h6>
												<p>{{ $t("bankjateng.status.unpaid.desc") }}</p>
											</b-col>
										</b-row>
										<b-button v-b-modal.registrationModal block variant="primary" @click="channel='JATENG'">{{ $t("bankjateng.status.unpaid.btn") }}</b-button>
									</div>
								</div>
							</div>
							<!-- <pre>{{programData}}</pre> -->

							<div class="bankjatengReg" v-if="ballotStatus.confirmedViaSaveDuit">
								<div class="groupLabel"><label>{{ $t("bankjateng.data.head") }}</label></div>
								<table>
									<tbody>
									<tr><td class="heady">
										{{ $t("bankjateng.data.name") }}
										</td>
										<td>
										{{programData.data.trnsUserName}}
									</td></tr>
									<tr><td class="heady">
										{{ $t("bankjateng.data.category") }}
										</td>
										<td>
										{{programData.linked.evrlTrnsId[0].evrlEvpaCategory}}
									</td></tr>
									<tr><td class="heady">
										{{ $t("bankjateng.data.bibname") }}
										</td>
										<td>
										{{programData.linked.evrlTrnsId[0].evpaBIBName}}
									</td></tr>
									<tr><td class="heady">
										{{ $t("bankjateng.data.community") }}
										</td>
										<td>
										{{programData.linked.evrlTrnsId[0].evpaCommunity}}
									</td></tr>
									<tr><td class="heady">
										{{ $t("bankjateng.data.jersey") }}
										</td>
										<td>
										{{programData.linked.evrlTrnsId[0].evpaJersey}}
									</td></tr>
									<tr><td class="heady">
										{{ $t("bankjateng.data.emergencyname") }}
										</td>
										<td>
										{{programData.linked.evrlTrnsId[0].evpaEmergencyContactName}}
									</td></tr>
									<tr><td class="heady">
										{{ $t("bankjateng.data.emergencycontact") }}
										</td>
										<td>
										{{programData.linked.evrlTrnsId[0].evpaEmergencyContactNumber}}
									</td></tr>
									<tr><td class="heady">
										{{ $t("bankjateng.data.medical") }}
										</td>
										<td>
										{{programData.linked.evrlTrnsId[0].evpaMedicalTreatment}}
									</td></tr>
									</tbody>
								</table>
							</div>
						</b-card>
				</b-col>
				<b-col md="6">
						<b-card
							:title="$t('friendship.card.head')"
							img-src="/public/images/fr.jpg"
							img-alt="Friendship Run"
							img-top
							class="dashCard dashDisabled"
						>
							<div class="friendshipCard">
								<b-card-text>
									{{ $t("friendship.card.desc") }}
								</b-card-text>
								<b-button v-b-modal.registrationModal block variant="primary" @click="channel='FRIENDSHIP'" disabled="disabled">{{ $t("friendship.card.btn") }}</b-button>
								<!-- <registration-modal/> -->
							</div>

							<div class="friendshipStatus" v-if="transactionStatus">
								<div class="statusPay">
									<b-row class="status">
										<b-col>
											<svg-image image="statusPay"/>
											<h6>{{ $t("friendship.status.pay.label") }}</h6>
											<i18n path="friendship.status.pay.desc" tag="p">
												<span place="timelimit"><strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong></span>
											</i18n>
											<!-- <p>Please ensure to make the payment before <strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong> to complete your Friendship Run registration.</p> -->
										</b-col>
									</b-row>
									<b-button v-b-modal.paymentModal block variant="primary">{{ $t("friendship.status.pay.btn") }}</b-button>
									<!-- <payment-modal :transactionData="transactionData"/> -->
								</div>
								<div class="statusUnpaid">
									<b-row class="status">
										<b-col>
											<svg-image image="statusUnpaid"/>
											<h6>{{ $t("friendship.status.unpaid.label") }}</h6>
											<p>{{ $t("friendship.status.unpaid.desc") }}</p>
										</b-col>
									</b-row>
									<b-button v-b-modal.registrationModal block variant="primary" @click="channel='FRIENDSHIP'">{{ $t("friendship.status.unpaid.btn") }}</b-button>
								</div>
								<div class="statusSuccess">
									<b-row class="status">
										<b-col>
											<svg-image image="statusSuccess"/>
											<h6>{{ $t("friendship.status.success.label") }}</h6>
											<p>{{ $t("friendship.status.success.desc") }}</p>
										</b-col>
									</b-row>
								</div>
							</div>

							<div class="friendshipReg" v-if="transactionStatus">
								<div class="groupLabel"><label>{{ $t("friendship.data.head") }}</label></div>
								<table>
									<tbody>
									<tr><td class="heady">
										{{ $t("friendship.data.code") }}
										</td>
										<td>
										LARI2020
									</td></tr>
									<tr><td class="heady">
										{{ $t("friendship.data.bib") }}
										</td>
										<td>
										1234
									</td></tr>
									</tbody>
								</table>	
								<b-button href="https://borobudurmarathon.com/friendship-run" block variant="primary">{{ $t("friendship.data.btn") }}</b-button>	
							</div>
						</b-card>
				</b-col>
			</b-row>
			<b-row class="dashRow">
				<b-col md="12">
					<b-card-group deck class="">
						<b-card
							:title="$t('shuttle.card.head')"
							img-src="/public/images/bus.jpg"
							img-alt="Shuttle Bus"
							img-top
							class="dashCard dashDisabled"
						>
							<div class="busCard">
								<b-card-text>
									{{ $t("shuttle.card.desc") }}
								</b-card-text>

								<b-button v-b-modal.busModal block variant="primary" disabled="disabled">{{ $t("shuttle.card.btn") }}</b-button>
								<bus-modal/>
							</div>

							<div class="busStatus" v-if="transactionStatus">
								<div class="statusPay">
									<b-row class="status">
										<b-col>
											<svg-image image="statusPay"/>
											<h6>{{ $t("shuttle.status.pay.label") }}</h6>
											<p v-html="$t('shuttle.status.pay.desc')"></p>
											<!-- <p>Please ensure to make the payment before <strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong> to complete your shuttle bus ticket.</p> -->
										</b-col>
									</b-row>
									<b-button v-b-modal.paymentModal block variant="primary">{{ $t("shuttle.status.pay.btn") }}</b-button>
									<!-- <payment-modal :transactionData="transactionData"/> -->
								</div>
								<div class="statusUnpaid">
									<b-row class="status">
										<b-col>
											<svg-image image="statusUnpaid"/>
											<h6>{{ $t("shuttle.status.unpaid.label") }}</h6>
											<p>{{ $t("shuttle.status.unpaid.desc") }}</p>
										</b-col>
									</b-row>
									<b-button v-b-modal.busModal block variant="primary">{{ $t("friendship.status.unpaid.btn") }}</b-button>
								</div>
								<div class="statusSuccess">
									<b-row class="status">
										<b-col>
											<svg-image image="iconBusTicket"/>
											<h6>{{ $t("shuttle.status.success.label") }}</h6>
											<p>{{ $t("shuttle.status.success.desc") }}</p>
										</b-col>
									</b-row>
								</div>
							</div>

							<div class="busTicket" v-if="transactionStatus">
								<table>
									<tbody>
									<tr><td class="heady">
										{{ $t("shuttle.data.code") }}
										</td>
										<td>
										BUS2020
									</td></tr>
									<tr><td class="heady">
										{{ $t("shuttle.data.point") }}
										</td>
										<td>
										Televisi Republik Indonesia Yogyakarta
									</td></tr>
									<tr><td class="heady">
										{{ $t("shuttle.data.dep") }}
										</td>
										<td>
										02.00 - 02.30 WIB (GMT+7)
									</td></tr>
									<tr><td class="heady">
										{{ $t("shuttle.data.ret") }}
										</td>
										<td>
										12.00 WIB (GMT+7)
									</td></tr>
									</tbody>
								</table>		
							</div>
						</b-card>
						<b-card
							:title="$t('bib.card.head')"
							img-src="/public/images/bib.jpg"
							img-alt="Bib Transfer"
							img-top
							class="dashCard dashDisabled"
						>
							<b-card-text>
								{{ $t("bib.card.desc") }}
							</b-card-text>

							<b-button v-b-modal.bibModal block variant="primary" disabled="disabled">{{ $t("bib.card.btn") }}</b-button>
							<bib-modal/>
						</b-card>
						<b-card
							:title="$t('raceday.card.head')"
							img-src="/public/images/rd.jpg"
							img-alt="Race Day"
							img-top
							class="dashCard dashDisabled"
						>
							<b-card-text>
							{{ $t("raceday.card.desc") }}
							</b-card-text>
							<b-button href="https://borobudurmarathon.com/race-day" block variant="primary">{{ $t("raceday.card.btn") }}</b-button>
					</b-card>
					</b-card-group>
				</b-col>
			</b-row>
			<b-row class="dashRow">
				<b-col md="8" v-if="racepackReady">
					<div class="mainCard">
						<b-card
							img-src="/public/images/rpc.jpg"
							img-alt="Race Pack Collection"
							img-top
						>
						<h2>{{ $t("rpc.card.head") }}</h2>
						<p>{{ $t("rpc.card.desc") }}</p>
						
						<div class="rpcInfo">
						<b-row>
							<b-col md="7" class="rpcSchedule" v-html="$t('rpc.schedule')">
							</b-col>
							<b-col md="5" v-html="$t('rpc.venue')">
							</b-col>
						</b-row>
						</div>

						<div class="groupLabel"><label>{{ $t("rpc.instructions.label") }}</label></div>
						<b-row class="rpcInstructions" v-if="ballotData">
							<b-col md="auto" class="rpcQR">
								<svg-image image="QR"/>
								<h6 style="color:#aaa">{{ballotData.mregOrderId}}</h6>
							</b-col>
							<b-col v-html="$t('rpc.instructions.point')">
							</b-col>
						</b-row>

						<b-button v-b-modal.delegationModal variant="primary">{{ $t("rpc.instructions.btn") }}</b-button>
						<delegation-modal/>
						
						<div class="rpcDelegated">
							<div class="groupLabel"><label>{{ $t("rpc.delegation.label") }}</label></div>
							<div class="statusTransferred">
								<b-row class="status">
									<b-col sm="auto">
										<svg-image image="iconDelegated"/>
									</b-col>
									<b-col>
										<h6>{{ $t("rpc.delegation.statuslabel") }}</h6>
										<p>{{ $t("rpc.delegation.statusdesc") }}</p>
									</b-col>
								</b-row>
							</div>
							<table><tbody>
								<tr>
									<td class="heady">{{ $t("rpc.delegation.rname") }}</td>
									<td>Pengambil Respek</td>
								</tr>
								<tr>
									<td class="heady">{{ $t("rpc.delegation.remail") }}</td>
									<td>pengambil@respek.com</td>
								</tr>
								<tr>
									<td class="heady">{{ $t("rpc.delegation.rphone") }}</td>
									<td>08123456789</td>
								</tr>
							</tbody></table>
						</div>
						<b-button variant="primary">{{ $t("rpc.delegation.cancel") }}</b-button>
						</b-card>
					</div>
				</b-col>
			</b-row>
		</div>
		<!-- <b-row class="mt-3">
			<b-col md="12">
				<h4>This Is Secured View</h4>
				<p><strong>Session Data : </strong></p>
				<pre>{{profile}}</pre>
			</b-col>		
		</b-row> -->
		</div>
	</b-container>
</template>

<script>
	import SvgImage from '../components/SvgImage.vue'
	// import VueTimepicker from '../../node_modules/vue2-timepicker/src/vue-timepicker.vue'
	import RegistrationModal from '../components/RegistrationModal.vue'
	import JerseyModal from '../components/JerseyModal.vue'
	import PaymentModal from '../components/PaymentModal.vue'
	import BusModal from '../components/BusModal.vue'
	import BibModal from '../components/BibModal.vue'
	import DelegationModal from '../components/DelegationModal.vue'
	import ConnectModal from '../components/ConnectModal.vue'
	export default {
		data() {
			return {
				invited : false,
				connectionPeriodOpen : false,
				countries : undefined,
				countryObject : {},
				event2020 : true,
				VReligible : true,
				VRSubmitted: undefined,
				VRMissed: undefined,
				VRactivated: true,
				submissionPeriodOpen: undefined,
				virtualEventClosed: true,
				virtualTransactionData: undefined,
				deliveringMerchandise: undefined,
				saveDuitOpen: false,
				forceEvenUnverified : true,
				programData : undefined,
				showJerseyModal : false,
				showPaymentModal : false,
				showConnectModal : false,
				targetConnectModal : undefined,
				racepackReady : undefined,
				showRaceDayInfo : undefined,
				transactionStatus : undefined,
				channel : null,
				patchShipped : undefined,
				userProfile : {},
				regChannels : {
					en : [
						{ text: '••• Select •••', value: null },
						{ text: 'Ballot Registration [Closed]', value: 'BALLOT', disabled:true },
						{ text: 'Fast Runner Qualifying [Closed]', value: 'FRQ', disabled:true },
						// { text: 'Travel Agent Partners [Closed]', value: 'TRAVEL', disabled:true },
					],
					id : [
						{ text: '••• Pilih •••', value: null },
						{ text: 'Pendaftaran Ballot [Ditutup]', value: 'BALLOT', disabled:true },
						{ text: 'Fast Runner Qualifying [Ditutup]', value: 'FRQ', disabled:true },
						// { text: 'Travel Agent Partners (Segara Hadir)', value: 'TRAVEL', disabled:true },
					],
				},
				categories : [
					{ text: '••• Select •••', value: null },
					{ text: 'Marathon', value: 1 },
					{ text: 'Half Marathon', value: 2 },
					{ text: '10K', value: 3 },
				],
				form : {
					evpaBIBName : null,
					evpaEvncId: null,
					evpaWave: null
				},
				formStatus : {
					evpaBIBName : {
						state : null
					},
					evpaEvncId : {
						state :  null
					},
					evpaWave : {
						state : null
					}
				},
				signedin : true,
				ballotStatus : {
					readyToRegister : false,
					confirmedViaBankJateng : false,
					FRQaccepted : undefined,
					eliteSelection : undefined
				},
				ballotData : undefined,
				ballotDataDetail : undefined,
				transactionData : undefined,
				transferInfo : undefined,
				FRQEntree : undefined,
				// fact : undefined,
				facts : {
					en : [
						'<p>If you circling across 4 stories of Borobudur Temple, you would have walked a total distance of approximately <strong>1.2 kilometers</strong>.</p>',
						'<p>Borobudur is a Buddhist stupa in the Mahayana tradition and it is <strong>the largest Buddhist monument</strong> in the world.</p>',
						'<p>Borobudur is surrounded by the walls and balustrades which are decorated with fine low reliefs, covering a <strong>total surface area of 2,520 meters²</strong>.</p>',
						'<p>Borobudur is decorated with <strong>2,672 relief panels</strong> and <strong>504 Buddha statues</strong>.</p>',
						'<p>Most temples were built on a flat surface while <strong>Borobudur was built on a bedrock hill</strong> located 265 meters above sea level and 15 meters above the floor of a dried-out paleolake.</p>',
						'<p>Approximately <strong>55,000 cubic meters</strong> of stone used in the construction of Borobudur were taken from neighboring rivers. These stone was cut to size, transported to the site and laid without mortar.</p>',
						'<p>Between 928 and 1006 CE, Borobudur was abandoned because the center of power moved to East Java. Soon after a series of volcanic eruptions took places and left <strong>Borobudur hidden for centuries</strong> under layers of volcanic ash and jungle growth.</p>',
						'<p>In the early 1900s, during the restoration of Borobudur, it was discovered that the 3 Buddhist temples in the region – Borobudur, Mendut and Pawon, are lined in <strong>one straight line position</strong>.</p>',
						'<p>The <strong>basic unit measurement</strong> used in the construction of Borobudur was called tala – the length of a human face from the forehead’s hairline to the tip of the chin or the distance from the tip of the thumb to the tip of the middle finger when both fingers are stretched at their maximum distance.</p>',
						'<p><strong>A hidden structure</strong> under the base was accidentally discovered in 1885. The ‘hidden foot’ contains reliefs, 160 of which are narrative describing the real Kamadhatu.</p>',
						'<p>Borobudur contains approximately <strong>2,672 individual bas-reliefs</strong>, 1,460 of which are narrative and 1,212 are decorative panels which cover the balustrades and facades.</p>',
						'<p><strong>Vesak</strong>, a festival commemorates the birth, enlightenment, and death of Gautama Buddha, is a ceremony that is centered at the 3 Buddhist temples in Borobudur region by walking from Mendut to Pawon and end up in Borobudur.</p>',
						'<p>Borobudur was built as <strong>an aquatic lotus</strong> symbol, seen as floating on the adjoining lake.</p>',
						'<p>Borobudur is composed of stone blocks. Each piece of stone is arranged <strong>without the use of cement or adhesive</strong>. These stones are only stacked and spliced ​​with certain patterns to bind each other.</p>',
						'<p>At first glance, all the Buddha statues in Borobudur appear similar, but there is <strong>a subtle difference</strong> between them in the mudras or the position of the hands. There are five groups of mudra: North, East, South, West and Zenith, which represent the five cardinal compass points according to Mahayana.</p>',
						'<p>Borobudur is equipped with a good drainage system to cater for the area’s high stormwater run-off. To prevent flooding, <strong>100 spouts are installed at each corner</strong>, each with a unique carved gargoyle in the shape of a giant or makara.</p>',
						'<p>The architect of Borobudur had used the <strong>4:6:9 ratio</strong> to lay out the precise dimensions of the fractal and self-similar geometry.</p>',
						'<p><strong>Gunadharma</strong> is claimed as the name of the architect of Borobudur. Many sources say that he came from the province of Lalitpur, Nepal.</p>',
					],
					id : [
						'<p><strong>1,2 kilometer</strong> adalah perkiraan jarak yang Anda tempuh jika mengelilingi seluruh Candi Borobudur dalam 4 tingkatannya.</p>',
						'<p>Borobudur adalah stupa Buddha dalam tradisi Mahayana yang menyandang gelar <strong>monumen Buddha terbesar</strong> di dunia.</p>',
						'<p>Borobudur dikelilingi oleh tembok dan langkan yang diisi oleh relief dekoratif, menyelimuti <strong>total area permukaan sebesar 2.520 meter²</strong>.</p>',
						'<p>Borobudur dihiasi oleh <strong>2.672 panel relief</strong> dan <strong>504 patung Buddha</strong>.</p>',
						'<p>Kebanyakan candi dibangun di atas permukaan datar sementara <strong>Borobudur dibangun di atas sebuah bukit batu</strong> setinggi 265 meter di atas permukaan laut dan 15 meter di atas dasar danau purba yang telah mengering.</p>',
						'<p>Sekitar <strong>55.000 meter kubik</strong> batu yang digunakan untuk membangun Borobudur diambil dari sungai sekitar. Batu-batu tersebut dipotong, dipindahkan ke lokasi dan disusun tanpa menggunakan campuran semen.</p>',
						'<p>Sekitar tahun 928 hingga 1006 setelah masehi, Borobudur ditinggalkan karena pusat kekuasaan saat itu berpindah ke Jawa Timur. Rangkaian letusan gunung berapi membuat <strong>Borobudur tertimbun selama beberapa abad</strong> di bawah lapisan abu vulkanik dan semak liar.</p>',
						'<p>Pada awal tahun 1900an, ketika masa pemulihan Borobudur, ditemukan bahwa 3 candi Buddha di daerah tersebut – Borobudur, Mendut dan Pawon, berada pada <strong>satu garis lurus</strong>.</p>',
						'<p><strong>Satuan ukuran baku</strong> yang digunakan dalam membangun Borobudur disebut tala – yaitu panjang wajah manusia dari garis rambut pada kening hingga ujung dagu atau panjang ujung ibu jari ke jari tengah ketika kedua jari direnggangkan pada jarak maksimum.</p>',
						'<p><strong>Struktur tersembunyi</strong> di bawah dasar ditemukan tidak disengaja pada tahun 1885. ‘Kaki tersembunyi’ ini menyimpan relief, dimana 160 di antaranya menceritakan Kamadhatu.</p>',
						'<p>Borobudur disusun atas <strong>2.672 relief</strong>, 1.460 di antaranya bersifat naratif sementara 1.212 lainnya bersifat dekoratif yang menghiasi fasad dan langkan.</p>',
						'<p><strong>Waisak</strong>, sebuah perayaan memperingati kelahiran, pencerahan, dan kematian Siddhartha Gautama, adalah perayaan yang dipusatkan pada 3 candi Buddha di area Borobudur. Dimulai dari berjalan dari Mendut ke Pawon dan berakhir di Borobudur.</p>',
						'<p>Borobudur dibangun sebagai simbol <strong>teratai air</strong>, terlihat mengapung di atas sebuah danau.</p>',
						'<p>Borobudur tersusun atas blok-blok batu. Setiap batu disusun <strong>tanpa menggunakan semen atau perekat</strong>. Batu-batu tersebut hanya disusun dan dipotong dengan pola tertentu untuk mengunci satu sama lain.</p>',
						'<p>Sekilas, seluruh patung Buddha di Borobudur tampak sama, tetapi terdapat <strong>perbedaan halus</strong> di antara mereka dalam kategori mudra atau sikap tangan simbolis. Terdapat lima kategori mudra: Utara, Timur, Selatan, Barat, dan Tengah, kesemuanya berdasarkan lima arah utama kompas menurut ajaran Mahayana.</p>',
						'<p>Borobudur dilengkapi sistem drainase air untuk mencegah banjir dengan <strong>100 pancuran yang terdapat di setiap sudut</strong>, masing-masing dihiasi pahatan raksasa atau makara.</p>',
						'<p>Arsitek Borobudur diyakini menggunakan <strong>rasio 4:6:9</strong> dalam menata ukuran geometri dalam konstruksi Borobudur secara presisi.</p>',
						'<p><strong>Gunadharma</strong> diklaim sebagai nama arsitek perancang Borobudur. Banyak sumber mengatakan bahwa ia berasal dari Lalitpur, Nepal.</p>',
					]
				},
				// profile: null
				trackerChannels : {
					endomondo : {
						internalId : undefined,
						connected : false,
						account : undefined
					},
					fit : {
						connected : false,
						account : undefined
					},
					garmin : {
						internalId : undefined,
						connected : false,
						account : undefined
					}
				}
			}
		},
		computed : {
			deliveryLocation : function(argument) {
				const availableLocationDetails = [];
				if (this.virtualTransactionData&&this.virtualTransactionData.linked.evrlTrnsId&&this.virtualTransactionData.linked.evrlTrnsId.length>0){				
					if (this.virtualTransactionData.linked.evrlTrnsId[0].evpaSubdistrict&&this.virtualTransactionData.linked.evrlTrnsId[0].evpaSubdistrict!='-'){
						availableLocationDetails.push(this.virtualTransactionData.linked.evrlTrnsId[0].evpaSubdistrict);
					}
					if (this.virtualTransactionData.linked.evrlTrnsId[0].evpaCity){
						availableLocationDetails.push(this.virtualTransactionData.linked.evrlTrnsId[0].evpaCity);
					}
					if (this.virtualTransactionData.linked.evrlTrnsId[0].evpaProvinsi){
						availableLocationDetails.push(this.virtualTransactionData.linked.evrlTrnsId[0].evpaProvinsi);
					}
					// if (this.virtualTransactionData.linked.evrlTrnsId[0].evpaCountry){
					// 	availableLocationDetails.push(this.virtualTransactionData.linked.evrlTrnsId[0].evpaCountry);
					// }
				}
				return availableLocationDetails.join(', ');
			},
			regChannel : function(){
				return this.regChannels[this.$i18n.locale]
			},
			fact : function(){
				return this.facts[this.$i18n.locale][Math.floor(Math.random() * this.facts[this.$i18n.locale].length)];
			},
			isLoggedIn : function(){ 
				return this.$store.getters.isLoggedIn
			}
		},
		// watch: {
		// 	'$i18n.locale': function(newVal, oldVal) {
		// 		console.log('locale change', newVal)
		// 	}
		// },
		components : {
			// VueTimepicker,
			SvgImage,
			RegistrationModal,
			JerseyModal,
			PaymentModal,
			BusModal,
			BibModal,
			DelegationModal,
			ConnectModal,
		},
		methods: {
			disconnectTracker(trackerName){
				trackerName.connected = false;
				trackerName.account = undefined;
				this.$store.dispatch('SETTRACKERSTATUS',{data:{trackerAccountId : trackerName.internalId, status:0}})
				console.log(trackerName);
			},
			toggleConnectModal(targetConnectModal){
				this.showConnectModal = !this.showConnectModal;
				this.targetConnectModal = targetConnectModal;
			},
			photoProfileError(event){
				event.target.src = "/public/images/anonymous.jpg"
				// console.log(this, event)
			},
			onSubmit(){

			},
			parseBallotStatus(){
				console.log('Define rule for ballot status : ', this.userProfile);
				console.log('Ballot Data : ', this.ballotData);
				this.ballotStatus.readyToRegister = true;
				if (this.ballotData){
					this.ballotStatus.readyToRegister = false;
					if (this.ballotData.mregStatus==1){
						this.ballotStatus.approved = true;
					} else {
						if (!this.userProfile.isSaveDuit){
							this.ballotStatus.waiting = true;
						}
					}
				}
				if (this.userProfile.fastRunnerInfo&&!this.userProfile.invitationDetail){
					this.ballotStatus.frqWaiting = true;
					this.ballotStatus.waiting = false;
					if (this.ballotStatus.approved){
						this.ballotStatus.FRQaccepted =true;
					}
				}
				if (this.transactionData&&this.transactionData.data.trnsConfirmed==1){
					this.ballotStatus.confirmed = true;
				}
				if (this.userProfile.invitationDetail&&!this.transactionData){
					this.ballotStatus.readyToRegister = true;
					this.ballotStatus.waiting = false;
				}
				if (this.userProfile.invitationDetail&&this.transactionData){
					this.ballotStatus.FRQwait = false;			
					this.ballotStatus.waiting = false;
					this.ballotStatus.eliteSelection = true;
				}
			},
			init(){
				this.$store.dispatch('GETPROFILE')
					.then((profileOut)=>{
						// this.profile = profileOut.data;
						this.$store.commit('SET_USER', {id: profileOut.data.data[0].id, user: profileOut.data});
						this.userProfile = this.$store.getters.getUserProfile;
						if (this.userProfile.memberLanguage){
							// console.log('language : ', this.userProfile.memberLanguage)
							if (this.userProfile.memberLanguage == 2){
								this.$i18n.locale = 'id';
							} else {
								this.$i18n.locale = 'en';
							}
						}
						if (this.userProfile.registeredEvents[228]){
							this.virtualData = this.userProfile.registeredEvents[228];
							if (this.virtualData.mrvrZmemId){							
								console.log('>>> User registered to virtual event : ', this.virtualData);
								this.$store.dispatch('GETPROFILEBYMEMBERID',{data:this.virtualData.mrvrZmemId})
									.then(profileOut=>{
										if (profileOut&&profileOut.data.length>0){
											this.VRactivated = true;
											profileOut.data.forEach(trac=>{
												this.trackerChannels[trac.tracTrackerApp].connected = true;
												this.trackerChannels[trac.tracTrackerApp].internalId = trac.tracId;
												if (trac.tracTrackerApp=='endomondo'){
													this.trackerChannels[trac.tracTrackerApp].account = JSON.parse(trac.tracTrackerProfileData).email;
												}
												if (trac.tracTrackerApp=='garmin'){
													this.trackerChannels[trac.tracTrackerApp].account = JSON.parse(trac.tracTrackerProfileData).emailAddress;
												}
												if (trac.tracTrackerApp=='fit'){
													this.trackerChannels[trac.tracTrackerApp].account = JSON.parse(trac.tracTrackerProfileData).email;
												}
											})
											// console.log('PRO : ', profileOut.data, this.trackerChannels);
										}
									})
									.catch((err)=>{
										console.log(err.response);
									})
							}
							if (this.virtualData.mrvrOrderId){							
								this.$store.dispatch('GETTRANSACTION', {data:this.virtualData.mrvrOrderId})
									.then((transactionOut)=>{
										this.$store.commit('SET_ACTIVE_TRANSACTION', {transaction:transactionOut});
										this.virtualTransactionData = transactionOut.data; //enable thissss
										// this.ballotDataDetail = transactionOut.data.linked.evrlTrnsId[0];
										// console.log('Transaction out : ', this.transactionData, this.ballotDataDetail);
										// this.parseBallotStatus();
										// this.transferInfo = this.transactionData.linked.jtvaTrnsId[0];
									})
									.catch((err)=>{
										console.log(err);
									})
							}
						}
						if (this.userProfile.readyToRegister||this.userProfile.registeredEvents[232]){
							if (this.userProfile.registeredEvents){
								if (this.userProfile.registeredEvents[208]&&!this.userProfile.invitationDetail){
									// this.ballotStatus.readyToRegister = true;
									//this.ballotStatus.waiting = true;
									// this.ballotStatus.approved = true;
									this.ballotData = this.userProfile.registeredEvents[208];
									this.$store.dispatch('GETTRANSACTION', {data:this.ballotData.mregOrderId})
										.then((transactionOut)=>{
											this.$store.commit('SET_ACTIVE_TRANSACTION', {transaction:transactionOut});
											this.transactionData = transactionOut.data;
											this.ballotDataDetail = transactionOut.data.linked.evrlTrnsId[0];
											console.log('Transaction out : ', transactionOut, this.ballotDataDetail);
											this.parseBallotStatus();
											// this.transferInfo = this.transactionData.linked.jtvaTrnsId[0];
										})
										.catch((err)=>{
											console.log(err);
										})
								}
								if (this.userProfile.registeredEvents[232]){
									this.ballotData = this.userProfile.registeredEvents[232];
									this.$store.dispatch('GETTRANSACTION', {data:this.ballotData.mregOrderId})
										.then((transactionOut)=>{
											this.$store.commit('SET_ACTIVE_TRANSACTION', {transaction:transactionOut});
											this.transactionData = transactionOut.data;
											this.ballotDataDetail = transactionOut.data.linked.evrlTrnsId[0];
											console.log('Transaction out : ', transactionOut, this.ballotDataDetail);
											this.parseBallotStatus();
											// this.transferInfo = this.transactionData.linked.jtvaTrnsId[0];
										})
										.catch((err)=>{
											console.log(err);
										})
								}
							}
							if (this.userProfile.registeredPrograms&&this.userProfile.registeredPrograms[208]){
								console.log('abuba... : ', this.userProfile.registeredPrograms);
								this.$store.dispatch('GETTRANSACTION', {data:this.userProfile.registeredPrograms[208].lptrOrderId})
									.then((transactionOut)=>{
										this.$store.commit('SET_ACTIVE_TRANSACTION', {transaction:transactionOut});
										this.programData = transactionOut.data;
										this.programData.isSaveDuit = true;
										if (this.programData.linked&&this.programData.linked.saduTrnsId&&this.programData.linked.saduTrnsId.length > 0){
											this.saduDetail = this.programData.linked.saduTrnsId[this.programData.linked.saduTrnsId.length-1];
											if (new Date(this.programData.data.trnsExpiredTime).getTime() < new Date().getTime()){
												this.ballotStatus.saveduitExpired = true;
											} else {
												this.ballotStatus.waitingSaveduitSettlement = true;
												// this.showPaymentModal = true;
												// console.log('Should show number...');
											}
										}
										if (this.programData.data&&this.programData.data.trnsConfirmed==1){
											this.ballotStatus.waitingSaveduitSettlement = false;
											this.ballotStatus.confirmedViaSaveDuit = true;
										}
										// this.ballotDataDetail = transactionOut.data.linked.evrlTrnsId[0];
										console.log('Transaction out : ', this.programData.data);
										// this.parseBallotStatus();
										// this.transferInfo = this.transactionData.linked.jtvaTrnsId[0];
									})
									.catch((err)=>{
										console.log(err);
									})
							}
							if (!this.$store.getters.skipPhoneVerification&&(!this.userProfile.profileComplete||!this.userProfile.phoneVerified)){
								// console.log('SSSSSS : ', this.$store.getters.skipPhoneVerification)
								this.$router.push('/profile');
							} else {
								this.parseBallotStatus();
								// this.ballotStatus.readyToRegister = false;
							}
						} else {
							// console.log('CCCCCCCCCC : ', this.userProfile.registeredPrograms[208]);
							if (this.forceEvenUnverified&&this.userProfile.registeredPrograms&&this.userProfile.registeredPrograms[208]){
								this.$store.dispatch('GETTRANSACTION', {data:this.userProfile.registeredPrograms[208].lptrOrderId})
									.then((transactionOut)=>{
										this.$store.commit('SET_ACTIVE_TRANSACTION', {transaction:transactionOut});
										this.programData = transactionOut.data;
										this.programData.isSaveDuit = true;
										if (this.programData.linked&&this.programData.linked.saduTrnsId&&this.programData.linked.saduTrnsId.length > 0){
											if (new Date(this.programData.data.trnsExpiredTime).getTime() < new Date().getTime()){
												this.ballotStatus.saveduitExpired = true;
											} else {
												this.ballotStatus.waitingSaveduitSettlement = true;
											}
											this.saduDetail = this.programData.linked.saduTrnsId[this.programData.linked.saduTrnsId.length-1];
										}
										// this.ballotDataDetail = transactionOut.data.linked.evrlTrnsId[0];
										console.log('Transaction out : ', this.programData.linked.saduTrnsId);
										// this.parseBallotStatus();
										// this.transferInfo = this.transactionData.linked.jtvaTrnsId[0];
									})
									.catch((err)=>{
										console.log(err);
									})
							}

							if (this.userProfile.profileComplete){
								// This is patch to force unverified member to register
								this.ballotStatus.readyToRegister = true;
								if (this.userProfile.registeredEvents&&this.userProfile.registeredEvents[208]&&!this.userProfile.invitationDetail){
									this.ballotStatus.readyToRegister = false;
									if (this.userProfile.registeredEvents[208]){
										// this.ballotStatus.readyToRegister = true;
										//this.ballotStatus.waiting = true;
										// this.ballotStatus.approved = true;
										this.ballotData = this.userProfile.registeredEvents[208];
										this.$store.dispatch('GETTRANSACTION', {data:this.ballotData.mregOrderId})
											.then((transactionOut)=>{
												this.$store.commit('SET_ACTIVE_TRANSACTION', {transaction:transactionOut});
												this.transactionData = transactionOut.data;
												this.ballotDataDetail = transactionOut.data.linked.evrlTrnsId[0];
												console.log('Transaction out : ', transactionOut, this.ballotDataDetail);
												// this.transferInfo = this.transactionData.linked.jtvaTrnsId[0];
											})
											.catch((err)=>{
												console.log(err);
											})
									}
									// console.log(this.userProfile.registeredEvents[208]);
								}
								// <<< This is patch to force unverified member to register
								// this.parseBallotStatus();
							} else {
								this.$router.push('/profile');
							}
							// console.log('aaaaa', this.userProfile);
						}
						console.log('User profile data : ', this.userProfile);
						if (this.userProfile.invitationDetail){
							this.invited = true;
							this.VReligible = false;
							this.regChannels.en.splice(1,0,{ text: 'Elite Race', value: 'ELITE'});
							this.regChannels.id.splice(1,0,{ text: 'Perlombaan Elite', value: 'ELITE'});
						}
						// if (this.userProfile.memberId > 16128){
							// this.VReligible = false;
						// }
					})
					.catch((err)=>{
						this.$router.push('/signin');
						console.log('profile error : ', err)
					})				
			}
		},
		mounted(){
			this.init();
			this.countries = this.$store.getters.getCountries;
			this.countries.forEach(country=>{
				this.countryObject[country.code] = country.name;
				// console.log(country);
			})
			// this.countryObject = this.$store.getters.getCountries;
			// this.fact = this.facts[Math.floor(Math.random() * this.facts.length)];
			// this.showPaymentModal = true;
			// this.$bvModal.show('paymentModal');
			// console.log(this.$bvModal);
			// this.$refs['paymentModal'].show();
			// this.$store.dispatch('REGISTEREVENT',{data:{id:1}})

			// this.$store.dispatch('CHECK')
			// 	.then((checkOut) =>{
			// 		console.log(checkOut);
			// 		this.data = checkOut.data;
			// 	})
			// 	.catch(err => {
			// 		console.log(err);
			// 	})
		},
	}
</script>


// WEBPACK FOOTER //
// HomeView.vue